import { ActionCard } from '@rsa-digital/evo-shared-components/components/ActionCard';
import { ChevronWrapper } from '@rsa-digital/evo-shared-components/components/ActionCard/ActionCard/styles';
import styled from 'styled-components';

export const StyledActionCard = styled(ActionCard)`
  ${ChevronWrapper} {
    display: flex;
    align-items: center;
  }
`;
